import { createFileRoute } from "@tanstack/react-router";
import WhatToHaveReadyResourceGuide from "@/pages/articles/WhatToHaveReadyResourceGuide";
export const Route = createFileRoute(
  "/what-to-have-ready-resource-guide-executive-assistant",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Resource Guide for Executive Assistants | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "A resource guide for executive assistants supporting a leader through depression treatment. Learn what to have ready in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content:
            "Resource Guide for Executive Assistants | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "A resource guide for executive assistants supporting a leader through depression treatment. Learn what to have ready in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/what-to-have-ready-resource-guide-executive-assistant",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/what-to-have-ready-resource-guide-executive-assistant",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <WhatToHaveReadyResourceGuide />;
}
